
import { Component, Vue } from 'vue-property-decorator';

import { SkeletonLoader, Grid } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader,
    Grid
  }
})
export default class Loading extends Vue {}
